import Pointer from "poin"
import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import Director from "@frog/source/juice/Director.js"
import Stage from "@frog/source/models/Stage.js"
import units from "@frog/source/data/units.js"
import skills from "@frog/source/data/skills.js"
import elements from "@frog/source/data/elements.js"
import Zone from "@frog/source/models/Zone.js"

import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import "@frog/source/views/ChapterUI.less"

export default class ChapterUI {
    render() {
        const stage = this.props.stage
        if(Dev.inProtoMode == true) return
        return (
            <div class="ChapterUI">
                <EscapeModal/>
                <Buttons stage={stage}/>
                <UnitSummary stage={stage}/>
                <PopupBox stage={stage}/>
                <ChapterStartBanner stage={stage}/>
                <MessageBanner stage={stage}/>
                <ChapterSuccessBanner stage={stage}/>
                <ChapterFailureBanner stage={stage}/>
                <TutorialMessages stage={stage}/>
                <EncounterName stage={stage}/>
            </div>
        )
        // <Inventory stage={stage}/>
        // <Tutorial stage={stage}/>
        // <EncounterDetails stage={stage}/>
        // <EncounterText stage={stage}/>
        // <PrepareModal/>
    }
}

class EncounterName {
    render() {
        const stage = this.props.stage
        if(stage == undefined) return
        if(stage.currentEncounter == undefined) return
        if(stage.encounters[stage.currentEncounter] == undefined) return
        if(stage.encounters[stage.currentEncounter].name == undefined) return

        return (
            <div class="EncounterName">
                {stage.encounters[stage.currentEncounter].name}
            </div>
        )
    }
}

class TutorialMessages {
    render() {
        if(this.props.stage?.dialogue != undefined) return

        if(App.game?.chapter?.hasTutorial == true
        && App.game?.chapter?.stage.currentEncounter == "1") {
            if(App.tutorial.hasKilled == true) {
                return (
                    <div class="TutorialPrompt" position="left">
                        <div class="Text">Excellent. Now end your turn. Let them fall upon your blade.</div>
                    </div>
                )
            }
            if(App.tutorial.hasMovedWithoutAttacking == true) {
                return (
                    <div class="TutorialPrompt" position="left">
                        <div class="Text">If need be, you can always undo.</div>
                    </div>
                )
            }
            if(App.tutorial.hasAttacked != true) {
                return (
                    <div class="TutorialPrompt" position="right">
                        <div class="Text">Show these devils your wrath.</div>
                    </div>
                )
            }
        }
        if(App.game?.chapter?.hasTutorial == true
        && this.props.stage.currentEncounter == "3") {
            if(App.tutorial.hasAttackedEffectivelyWithEarth == true) {
                return (
                    <div class="TutorialPrompt" position="right">
                        <div class="Text">
                            The <span class="green">axe</span> cleaves
                            through <span class="blue">spears</span>!
                        </div>
                    </div>
                )
            }
            if(App.tutorial.hasAttackedIneffectively == true) {
                return (
                    <div class="TutorialPrompt" position="left">
                        <div class="Text">
                            Our <span class="red">sword</span> finds no
                            purchase against <span class="blue">spears</span>.
                            <br/><br/>
                            If need be, we can always undo.
                        </div>
                    </div>
                )
            }
            return (
                <div class="TutorialPrompt" position="right">
                    <div class="Text">
                        These devils wield vile <span class="blue">spears</span>
                        <br/><br/>
                        <span class="blue">Spears</span> are strong
                        against <span class="red">swords</span>, and will do 2x the damage.
                    </div>
                </div>
            )
        }
        if(App.game?.chapter?.hasTutorial == true
        && this.props.stage.currentEncounter == "5") {
            if(App.tutorial.hasSeenBoss == true) {
                return (
                    <div class="TutorialPrompt" position="left">
                        <div class="Text">
                            Before us is Ire, the archdevil of wrath.
                            <br/><br/>
                            Their rage ends here.
                        </div>
                    </div>
                )
            }
        }

        if(App.game?.chapter?.slug == "avarice"
        && this.props.stage.currentEncounter == "1") {
            if(App.tutorial.hasRecruitedShield == true) {
                return (
                    <div class="TutorialPrompt" position="right">
                        <div class="Text">
                            Though she seems stuck, this Shield can still protect her allies.
                            <br/><br/>
                            <span class="green">Swap</span> with your ally by clicking on them.
                        </div>
                    </div>
                )
            }
        }

        // This armored knight can surmount all blows, if only they could reach

        if(App.game?.chapter?.slug == "avarice"
        && this.props.stage.currentEncounter == "2") {
            if(App.tutorial.isShieldExhausted == true) {
                return (
                    <div class="TutorialPrompt" position="right">
                        <div class="Text">
                            <span class="green">Rally</span> your shield, surge forth oncemore, and engage the foe!
                        </div>
                    </div>
                )
            }
            return (
                <div class="TutorialPrompt" position="right">
                    <div class="Text">
                        All heroes support their comrades.
                        <br/><br/>
                        The Swordlord can <span class="green">Rally</span> exhausted allies to move twice.
                    </div>
                </div>
            )
        }
        return (
            <div class="TutorialPrompt" isHidden={true}/>
        )
    }
}

class EscapeModal {
    render() {
        if(Navigation.state.escape == undefined) return
        return (
            <div class="EscapeModal">
                <div class="Grayout" onClick={() => Navigation.state.escape = undefined}/>
                <div class="PlayerOptions" onClick={(event) => event.stopPropagation()}>
                    <div class="Header">PAUSED</div>
                    <div class="Option" onClick={() => Navigation.go("/title")}>Main Menu</div>
                    <div class="Option">Settings</div>
                    <hr/>
                    <div class="Option" onClick={this.restart}>Restart</div>
                    <div class="Option" onClick={() => Navigation.state.escape = undefined}>Resume</div>
                </div>
                {this.dev}
            </div>
        )
    }
    get dev() {
        if(Dev.isEnabled != true) return
        return (
            <div class="Dev" onClick={(event) => event.stopPropagation()}>
                <div class="Options">
                    <div class="Option" onClick={this.toggleDeath} isEnabled={Dev.isAllyDeathEnabled}>😇</div>
                    <div class="Option" onClick={this.toggleCollision} isEnabled={Dev.isAllyCollisionEnabled}>👻</div>
                    <div class="Option" onClick={this.killAllEnemies}>💀</div>
                </div>
            </div>
        )
    }
    restart() {
        Navigation.state.escape = undefined
        App.game.chapter.restart()
    }
    toggleDeath() {
        Dev.isAllyDeathEnabled = !Dev.isAllyDeathEnabled
        App.game.chapter.recalculateStage()
    }
    toggleCollision() {
        Dev.isAllyCollisionEnabled = !Dev.isAllyCollisionEnabled
        App.game.chapter.recalculateStage()
    }
    killAllEnemies() {
        App.game.chapter.killAllEnemies()
    }
}

class Buttons {
    render() {
        if(App.game.chapter.phase != "play") return
        if(App.game.chapter.hasUndoEndTurnButtons === false) return
        if(this.props.stage?.dialogue != undefined) return

        return [
            <div class="EndTurnButton" onClick={this.onEndTurn}>
                <div class="Text">End Turn</div>
                <div class="Shortcut">{App.mode == "gamepad" ? "(y)" : "enter"}</div>
                <div class="Charge" style={{"width": Math.min(100, App.game.chapter.selection.endTurnCharge / App.game.chapter.selection.maxendTurnCharge * 100).toFixed(2) + "%"}}/>
            </div>,
            <div class="UndoButton" onClick={this.onUndo}>
                <div class="Text">Undo</div>
                <div class="Shortcut">{App.mode == "gamepad" ? "(bumper)" : "z"}</div>
            </div>
        ]
    }
    get onUndo() {
        return (event) => {
            event.stopPropagation()
            App.game.chapter.undoAction()
        }
    }
    get onEndTurn() {
        return (event) => {
            if(Director.isPerforming != true) {
                event.stopPropagation()
                App.game.chapter.endPlayerTurn()
            }
        }
    }
}

class UnitSummary {
    render() {
        if(this.props.stage?.dialogue != undefined) return

        const selection = App.game.chapter.selection
        const selectedUnitKey = selection.selectedUnitKey || selection.hoveredUnitKey
        const selectedUnit = this.props.stage.units[selectedUnitKey]

        if(selection.hoveredAction?.type == "invoke skill") {
            const targetUnit = Stage.findUnitByPosition(this.props.stage, selection.hoveredAction.position)
            return (
                <div class="UnitSummary">
                    <UnitDetails unit={selectedUnit} position={"left"}/>
                    <UnitDetails unit={targetUnit} position={"right"}/>
                </div>
            )
        }

        return (
            <div class="UnitSummary">
                <UnitDetails unit={selectedUnit} position={selectedUnit?.affiliation == "good" ? "left" : "right"}/>
            </div>
        )
    }
}

class UnitDetails {
    render() {
        if(this.props.unit == undefined) return
        if(this.props.unit.type == "zone") return

        const unit = this.props.unit
        const omegaunit = App.game.chapter.selection?.hoveredAction?.omegastage?.units[unit.key]

        const element = elements[unit.element]
        const strongElement = elements[elements[unit.element].strengths[0]]
        const weakElement = elements[elements[unit.element].weaknesses[0]]

        const isSelected = this.props.unit.key == App.game.chapter.selection.selectedUnitKey

        return (
            <div class="UnitDetails" key={unit?.key} position={this.props.position} isSelected={isSelected}>
                <div class="Profile">
                    <div class="Summary">
                        <div class="Portrait">
                            <img src={unit?.portraits?.base}/>
                        </div>
                        <div class="Properties">
                            <div class="Name">
                                <span class="Text">
                                    {unit.title || unit.name}
                                </span>
                            </div>
                            <div class="Class">
                                <span class="Text">
                                    {unit.subtitle || unit.jobName}
                                </span>
                            </div>
                            <UnitHealthBar unit={unit} omegaunit={omegaunit}/>
                        </div>
                    </div>
                    <div class="Stats">
                        <div class="Health">
                            <div class="Value">{unit.health}/{unit.maxhealth}</div>
                            <div class="Label">HP</div>
                        </div>
                        <div class="Element">
                            <div class="Line">
                                <span class="Icon" style={{"background-color": elements[element.key].color}}/>
                                <span class="Label">{element.name}</span>
                            </div>
                            <div class="Effectiveness">
                                <div class="Line">
                                    <div class="Icon" style={{"background-color": elements[strongElement.key].color}}/>
                                    2x vs {strongElement.name}
                                </div>
                                <div class="Line">
                                    <div class="Icon" style={{"background-color": elements[weakElement.key].color}}/>
                                    ½ vs {weakElement.name}
                                </div>
                            </div>
                        </div>
                        <div class="Stat">
                            <div class="Label">Attack:</div>
                            <div class="Value">{unit.power}</div>
                        </div>
                        <div class="Stat">
                            <div class="Label">Defense:</div>
                            <div class="Value">{unit.defense}</div>
                        </div>
                        <div class="Stat">
                            <div class="Label">Resistance:</div>
                            <div class="Value">{unit.resistance}</div>
                        </div>
                    </div>
                </div>
                <div class="Skills" side="bottom-left">
                    {Object.values(unit.skills).map((skillKey, index) => {
                        const skill = skills.get(skillKey)
                        if(skill == undefined) return
                        if(skill.isHidden == true) return
                        if(unit.affiliation != "good") return
                        if(App.game?.chapter?.slug == "wrath") return
                        return (
                            <div class="Skill"
                                canSelect={App.game.chapter.selection.activeUnit.energy["invoke skill"] != false}
                                onMouseUp={(event) => event.stopPropagation()}
                                onMouseDown={(event) => event.stopPropagation()}
                                onClick={(event) => App.game.chapter.selection.selectedSkillKey = skillKey}
                                onMouseOver={(event) => App.game.chapter.selection.hoveredSkillKey = skillKey}
                                onMouseOut={(event) => App.game.chapter.selection.hoveredSkillKey = undefined}
                                isSelected={App.game.chapter.selection.isSelectedSkill(skillKey, unit)}>
                                <div class="Label">
                                    {skill.name || skillKey}
                                </div>
                                <div class="Number">
                                    {index + 1}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

class PopupBox {
    render() {
        if(this.props.stage.dialogue == undefined) return

        if(this.props.stage.dialogue.type == "CharacterSplashBox") {
            return <CharacterSplashBox stage={this.props.stage}/>
        } else if(this.props.stage.dialogue.type == "banner") {
            return <BannerPopupBox stage={this.props.stage}/>
        } else {
            return <DialogueBox stage={this.props.stage}/>
        }
    }
}

class CharacterSplashBox {
    render() {
        const stage = this.props.stage
        const dialogue = this.props.stage.dialogue
        const unit = stage.units[dialogue?.data?.unitKey]
        if(dialogue == undefined) return
        if(unit == undefined) return
        return (
            <div class="CharacterSplashBox">
                <div class="Box">
                    <section class="HeaderSection">
                        <div class="Name">{unit.name}</div>
                        <div class="Declaration">has joined your party!</div>
                    </section>
                    <section class="MainSection">
                        <div class="Thumbnail">
                            <UnitSprite unit={unit}/>
                        </div>
                        <div class="Stats">
                            <div class="Health">
                                <div class="Label">{unit.health}HP</div>
                                <UnitHealthBar unit={unit}/>
                            </div>
                            {unit.facts && unit.facts.map((fact) => {
                                return (
                                    <div class="Fact">
                                        {fact}
                                    </div>
                                )
                            })}
                            <div class="Stat">
                                <div class="Label">Attack:</div>
                                <div class="Value">{unit.power}</div>
                            </div>
                            <div class="Stat">
                                <div class="Label">Defense:</div>
                                <div class="Value">{unit.defense}</div>
                            </div>
                            <div class="Stat">
                                <div class="Label">Resistance:</div>
                                <div class="Value">{unit.resistance}</div>
                            </div>
                        </div>
                    </section>
                    <section class="FlavorTextSection">
                        flavor text flavor text flavor text flavor text
                        flavor text flavor text flavor text flavor text
                        flavor text flavor text flavor text flavor text
                        flavor text flavor text flavor text flavor text
                        flavor text flavor text flavor text flavor text
                        flavor text flavor text flavor text flavor text
                    </section>
                </div>
            </div>
        )
    }
}
class BannerPopupBox {
    render() {
        return (
            <div class="BannerPopupBox" style={this.style}>
                <div class="Text">{this.props.stage.dialogue.text}</div>
            </div>
        )
    }
    get style() {
        return {
            "background-color": this.props.stage.dialogue.data?.color
        }
    }
}

class DialogueBox {
    render() {
        return (
            <div class="Dialogue">
                {this.scene}
                {this.box}
            </div>
        )
    }
    get box() {
        const dialogue = this.props.stage.dialogue
        if(dialogue == undefined) return

        return (
            <div class="Box">
                {this.name}
                {this.words}
            </div>
        )
    }
    get words() {
        const dialogue = this.props.stage.dialogue
        if(dialogue.text == undefined) return
        let words = dialogue.text
        // words = words.replace("<i>", "").replace("</i>", "")
        // if(dialogue.index != undefined) {
        //     words = words.substring(0, dialogue.index)
        // }
        // {words.split("<br>").filter((text) => text != "").map((subwords) => {
        //     return (
        //         <div class="TextLine">{subwords}</div>
        //     )
        // })}

        return (
            <div class="Words">
                {words.split("").map((character, index) => {
                    return (
                        <div class="Character" style={{"opacity": index <= dialogue.index ? 1 : 0}}>
                            {character}
                        </div>
                    )
                })}
            </div>
        )
    }
    get name() {
        const dialogue = this.props.stage.dialogue

        const unit = this.props.stage.units[dialogue.data.unitKey]

        if(dialogue.data?.unitKey != undefined
        && unit != undefined) {
            return (
                <div class="Name">
                    <div class="Bolder Text">{unit.title || unit.name}</div>
                    <div class="Smaller Text">{unit.subtitle || unit.jobName}</div>
                </div>
            )
        }

        if(dialogue.data?.speakerName != undefined) {
            return (
                <div class="Name">
                    <div class="Bolder Text">{dialogue.data.speakerName}</div>
                </div>
            )
        }
    }
    get scene() {
        const dialogue = this.props.stage.dialogue
        if(dialogue?.tags?._ == "fullscreen") {
            return (
                <div class="Black"/>
            )
        }

        if(dialogue.characters == undefined) return

        return (
            <div class="Scene">
                {Object.keys(dialogue.characters).map((key) => {
                    if(units[key] == undefined) return
                    const unit = units[key]

                    const isSpeaking = dialogue.speakingCharacter == key
                    const direction = dialogue.characters[key].tags["direction"] || "left"
                    const position = dialogue.characters[key].tags["position"] || 1
                    const expression = dialogue.characters[key].tags["expression"] || "base"
                    const flourish = dialogue.characters[key].tags["flourish"] || "shift"
                    const image = unit.portraits[expression]

                    return (
                        <img class="Portrait" src={image} direction={direction} position={position} expression={expression} flourish={flourish} isSpeaking={isSpeaking}/>
                    )
                })}
            </div>
        )
    }
}

class ChapterStartBanner {
    render() {
        const step = App.game?.chapter?.sequence?.steps[0]
        if(step == undefined) return
        if(step.type != "chapter start") return
        step.data = step.data || []
        return (
            <div class="ChapterStartBanner">
                <div class="Chapter">{step.data[0] || "Chapter 1"}</div>
                <div class="Title">{step.data[1] || "The Beginning"}</div>

                <div class="InWhich">{step.data[2]}</div>
                <div class="First Subtitle">{step.data[3]}</div>
                <div class="Second Subtitle">{step.data[4]}</div>
            </div>
        )
    }
}

class MessageBanner {
    render() {
        const step = App.game?.chapter?.sequence?.steps[0]
        if(step == undefined) return
        if(step.type != "turn start") return

        return (
            <div class="MessageBanner">
                <div class="Message">
                    {step.message}
                </div>
            </div>
        )
    }
}

class ChapterSuccessBanner {
    render() {
        const step = App.game?.chapter?.sequence?.steps[0]
        if(step == undefined) return
        if(step.type != "chapter success") return

        return (
            <div class="ChapterSuccessBanner">
                <div class="Declaration">Victory!!</div>
            </div>
        )
    }
}

class ChapterFailureBanner {
    render() {
        const step = App.game?.chapter?.sequence?.steps[0]
        if(step == undefined) return
        if(step.type != "chapter failure") return

        return (
            <div class="ChapterFailureBanner">
                <div class="Predeclaration">We have been</div>
                <div class="Declaration">Defeated</div>
            </div>
        )
    }
}
